import axios from 'src/api/axiosInstances/privateAxiosInstance';
import CategoryList from '../types/CategoryList';
import CustomFilters from '../types/CustomFilters';
import ProductSegmentLookup from '../types/ProductSegmentLookup';
import ProductAssociationLookup from '../types/ProductAssociationLookup';

export type SourceOwnerDataItem = {
  id: string;
  name: string;
  isDefault: boolean;
};

type SourceOwnerData = {
  sourceOwner: SourceOwnerDataItem[];
};

export type ManufacturersData = {
  manufacturers: ManufacturersDataItem[];
};

export type ManufacturersDataItem = {
  id: number;
  name: string;
};

type ManufacturersParams = {
  ownerId: string;
  manufacturer: string;
};

type ManufacturersIdsParams = {
  manufacturerIds: string;
};

export const getSourceOwner = (): Promise<SourceOwnerData> => {
  return axios.get('/qm/sourceowner');
};

export const getLookupCategories = (params: CategoryList.Params): Promise<CategoryList.Response> => {
  return axios.get('/qm/category/list', { params });
};

export const getLookupCustomFilters = (params: CustomFilters.Params): Promise<CustomFilters.Response> => {
  return axios.get('/qm/product/customfilter', { params });
};

export const getManufacturers = (params: ManufacturersParams): Promise<ManufacturersData> => {
  return axios.get('/qm/productsegment/manufacturer', { params });
};

export const getManufacturersByIds = (params: ManufacturersIdsParams): Promise<ManufacturersData> => {
  return axios.get('/qm/manufacturer/retrievebyid', { params });
};

export const addProductAssociationLookup = (data: ProductAssociationLookup): Promise<unknown> => {
  return axios.post('/qm/productsegment/addlookup', data);
};

export const getProductSegmentLookup = (productSegmentId: number): Promise<ProductSegmentLookup.Response> => {
  return axios.get(`/qm/productsegment/retrievelookups?productsegmentid=${productSegmentId}`);
};
